import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState("user@gmail.com");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (!loading) {
      setLoading(true);
      setTimeout(function () {
        if (username === "user@gmail.com") {
          setLoading(false);
          navigate("/otp", {
            state: {
              username,
              otptype: e.nativeEvent.submitter.name.replace("button", ""),
            },
          });
        } else {
          setLoading(false);
          alert("Invalid credentials");
        }
      }, 1000);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-innerwrap text-center">
        <svg
          width="73"
          height="72"
          viewBox="0 0 73 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M18.6829 48.2678H10.2362C9.82981 48.2678 9.50024 48.6032 9.50024 49.0168V53.2486C9.50024 53.6616 9.82981 53.997 10.2362 53.997H18.6829C19.0893 53.997 19.4182 53.6616 19.4182 53.2486V49.0168C19.4182 48.6032 19.0893 48.2678 18.6829 48.2678Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M62.7633 34.1846H62.0407H54.3166H44.6285L42.5743 35.0144L39.2679 38.242L34.9016 42.505L29.6388 47.643C29.2337 48.0382 28.685 48.2603 28.1135 48.2603H25.0979C24.6998 48.2603 24.3766 48.5772 24.3766 48.9673V53.2901C24.3766 53.6808 24.6998 53.9971 25.0979 53.9971H28.1135C30.2477 53.9971 32.2562 53.1826 33.7688 51.7068L37.6607 47.9071L39.9632 52.4132L42.5793 53.9971H51.9868C52.3849 53.9971 52.7082 53.6808 52.7082 53.2901V48.9679C52.7082 48.5778 52.3849 48.2616 51.9868 48.2616H44.3865L42.0275 43.6435L45.8515 39.9099H54.2994C54.3052 39.9099 54.3102 39.9131 54.3166 39.9131H62.7633C63.1697 39.9131 63.4986 39.5784 63.4986 39.1648V34.9329C63.4986 34.5193 63.1697 34.1846 62.7633 34.1846Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M54.3171 23.7315H62.7644C63.1702 23.7315 63.4998 23.3961 63.4998 22.9825V18.7507C63.4998 18.3377 63.1702 18.0029 62.7644 18.0029H54.3171C53.9107 18.0029 53.5818 18.3377 53.5818 18.7507V22.9825C53.5818 23.3961 53.9107 23.7315 54.3171 23.7315Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clip-rule="evenodd"
            d="M10.2356 37.8155H10.9582H18.6829H28.3704L30.4246 36.9857L33.731 33.758L38.0979 29.4944L43.3601 24.357C43.7652 23.9612 44.3138 23.7391 44.886 23.7391H47.9009C48.2991 23.7391 48.6223 23.4228 48.6223 23.0327V18.7099C48.6223 18.3192 48.2991 18.0029 47.9009 18.0029H44.886C42.7511 18.0029 40.7426 18.8168 39.2301 20.2932L35.3382 24.0929L33.0363 19.5862L30.4195 18.0029H21.0121C20.6139 18.0029 20.2907 18.3192 20.2907 18.7099V23.0315C20.2907 23.4216 20.6139 23.7385 21.0121 23.7385H28.6123L30.9713 28.3566L27.1474 32.0901H18.7C18.6937 32.0895 18.6893 32.0863 18.6829 32.0863H10.2356C9.82917 32.0863 9.50024 32.4217 9.50024 32.8347V37.0665C9.50024 37.4801 9.82917 37.8155 10.2356 37.8155Z"
            fill="black"
          />
        </svg>

        <h1>Backend-Frontend Activity Demo</h1>
        <form onSubmit={handleLogin}>
          <div class="form-floating mb-4">
            <input
              type="email"
              class="form-control"
              value={username}
              id="floatingInput"
              onChange={(e) => setUsername(e.target.value)}
              placeholder="name@example.com"
              required
            />
            <label for="floatingInput">Registered email</label>
          </div>

          <button name="emailbutton" type="submit" className="btn btn-primary">
            {loading && (
              <div class="spinner-border spinner-border-sm" role="status"></div>
            )}
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6667 3.33325H3.33335C2.41669 3.33325 1.67502 4.08325 1.67502 4.99992L1.66669 14.9999C1.66669 15.9166 2.41669 16.6666 3.33335 16.6666H16.6667C17.5834 16.6666 18.3334 15.9166 18.3334 14.9999V4.99992C18.3334 4.08325 17.5834 3.33325 16.6667 3.33325ZM16.3334 6.87492L10.4417 10.5583C10.175 10.7249 9.82502 10.7249 9.55835 10.5583L3.66669 6.87492C3.45835 6.74159 3.33335 6.51659 3.33335 6.27492C3.33335 5.71659 3.94169 5.38325 4.41669 5.67492L10 9.16659L15.5834 5.67492C16.0584 5.38325 16.6667 5.71659 16.6667 6.27492C16.6667 6.51659 16.5417 6.74159 16.3334 6.87492Z"
                fill="white"
              />
            </svg>
            Get an email with access code
          </button>
          <div className="mt-1 mb-1">OR</div>
          <button name="smsbutton" type="submit" className="btn btn-secondary">
            {loading && (
              <div class="spinner-border spinner-border-sm" role="status"></div>
            )}
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.6667 0.841585L6.33335 0.833252C5.41669 0.833252 4.66669 1.58325 4.66669 2.49992V17.4999C4.66669 18.4166 5.41669 19.1666 6.33335 19.1666H14.6667C15.5834 19.1666 16.3334 18.4166 16.3334 17.4999V2.49992C16.3334 1.58325 15.5834 0.841585 14.6667 0.841585ZM14.6667 15.8333H6.33335V4.16659H14.6667V15.8333Z"
                fill="#00627E"
              />
            </svg>
            Get an SMS with access code
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
